import { render, staticRenderFns } from "./ListFiches.vue?vue&type=template&id=f5b8d248&scoped=true&"
import script from "./ListFiches.vue?vue&type=script&lang=js&"
export * from "./ListFiches.vue?vue&type=script&lang=js&"
import style0 from "./ListFiches.vue?vue&type=style&index=0&id=f5b8d248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b8d248",
  null
  
)

export default component.exports